import { render, staticRenderFns } from "./GenotypeDatasetTable.vue?vue&type=template&id=61937488&"
import script from "./GenotypeDatasetTable.vue?vue&type=script&lang=js&"
export * from "./GenotypeDatasetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports